import { QueryCache, QueryClient } from "@tanstack/react-query";
import { toast } from "sonner";
import { getMessages } from "$/modules/i18n/lib/i18n";

export const QUERY_STALE_TIME = 30_000;
export const QUERY_GC_TIME = 10 * 60_000;

export function createQueryClient() {
	return new QueryClient({
		queryCache: new QueryCache({
			onError: (error, query) => {
				console.error("Query failed:", query.queryKey, error);
				if (query.state.data !== undefined) {
					const locale =
						globalThis.location?.pathname.split("/")[1] === "en" ? "en" : "de";
					void getMessages({ locale }).then((messages) =>
						toast.error(messages.common.refreshFailed, {
							description: error.message,
						}),
					);
				}
			},
		}),
		defaultOptions: {
			queries: {
				staleTime: QUERY_STALE_TIME,
				gcTime: QUERY_GC_TIME,
				retry: (failureCount, error) => {
					const code = "code" in error ? error.code : undefined;
					if (typeof code === "number" && code >= 400 && code < 500) {
						return false;
					}
					return failureCount < 1;
				},
				refetchOnWindowFocus: true,
				refetchOnReconnect: true,
			},
		},
	});
}

export const queryClient = createQueryClient();
